import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class NotifyxService {

  constructor() { }

  /**
   * @name presentAlert
   * @param title Alert title
   * @param msg Alert body message
   * @param type Alert type as 'success','error'
   */
  presentAlert(title:string, msg:string, icon:any) {
    Swal.fire(title, msg, icon);
  }

  presentToast(title:string, icon:any){
    Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 4000,
      title,
      icon
    })
  }

  customAlert(title:string, text:string, icon: any){
    Swal.fire({
      position: 'top-end',
      title,
      text,
      showConfirmButton: false,
      timer: 3000,
      icon
    })
  }

  confirmAlert(msgtitle:string, msgtext:string, msgicon:any, confirmButText:string, cancelButText:string, confirmAction:any, cancelAction?:any){
    Swal.fire({
      title: msgtitle,
      text: msgtext,
      icon: msgicon,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: confirmButText,
      cancelButtonText: cancelButText
    }).then((isConfirmed:any) => {
      if (isConfirmed.value) {
        confirmAction();
      } else if (isConfirmed.dismiss === Swal.DismissReason.cancel) {
        cancelAction();
      }
    });
  }

  /**
   * @name Console log system messages for error purpose
   * @param title
   * @param msg Data
   */
  log(title:string,msg:string){
    console.log(title, msg);
  }
}
